import React from 'react';

const AvatarUpload = () => (
  <div className="flex flex-col items-center mb-4">
    <div className="w-20 h-20 border-2 border-dashed rounded-full flex items-center justify-center text-4xl text-gray-400 mb-2 cursor-pointer">
      +
    </div>
  </div>
);

export { AvatarUpload };
